import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import withStyles from 'react-jss'
import compose from '@shopify/react-compose'

import styles from './page-title-style'

const PageTitle = props => {
  const container = document.getElementById('page-title')
  
  if (container) {
    return ReactDOM.createPortal(<h1 className={props.classes.title}>{props.t(props.i18nKey)}</h1>, container)
  }

  return null
}

PageTitle.propTypes = {
  i18nKey: PropTypes.string.isRequired,
}

export default compose(
  withTranslation(),
  withStyles(styles),
)(PageTitle)
